import gql from 'graphql-tag';

export const CCA_GENERATION_JOB_QUERY = gql`
  query CcaGenerationJobQuery($id: ID!) {
    ccaGenerationJob(id: $id) {
      id
      status
      errorMessage
      successes {
        articleId
        templateId
        templateName
        creativesGenerated
        generationId
      }
      failures {
        articleId
        templateId
        templateName
        reason
        templateDriftMessage
      }
      errors
    }
  }
`;
